import { useEffect, useState } from 'react';

const DESKTOP_HOVER_QUERY = '(hover: hover) and (pointer: fine)';

/** True only for a mouse/trackpad-style primary pointer. Touch stays click-first. */
export function useDesktopHover(): boolean {
  const [desktopHover, setDesktopHover] = useState(() =>
    typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(DESKTOP_HOVER_QUERY).matches,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const media = window.matchMedia(DESKTOP_HOVER_QUERY);
    const update = (): void => setDesktopHover(media.matches);
    update();
    media.addEventListener?.('change', update);
    return () => media.removeEventListener?.('change', update);
  }, []);

  return desktopHover;
}
